module.exports = __webpack_public_path__ + "static/media/ReportInactiveIcon.cdd60b54.svg";